<template>
  <div class="mod">
    <div class="box">
      <span class="hd" :lines="undefined">{{ hd }}</span>
      <span class="bd" :lines="undefined">{{ bd }}</span>
      <div class="main">
        <div class="wrap">
          <img class="admin" :src="admin" />
          <span class="info" :lines="undefined">{{ info }}</span>
        </div>
        <span class="sourceCode" :lines="undefined">{{ sourceCode }}</span>
        <div class="block">
          <div class="color" />
          <img class="lianjie" :src="lianjie" />
          <span class="email" :lines="undefined">{{ email }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hd: '项目名称',
      bd:
        '设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考',
      admin:
        require('./images/img_28940_0_0.png'),
      info: '作者/公司名称',
      sourceCode: '源代码',
      lianjie:
        require('./images/img_28940_0_1.png'),
      email: 'cedvijwo@madag.com'
    };
  },
  methods: {}
};
</script>
<style>
@import './index.response.css';
</style>
